import React, { useEffect, useState } from 'react'
import { CNav, CNavItem, CNavLink, CCol, CFormLabel, CButton, CCardBody, CCard, CFormInput, CRow } from '@coreui/react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'
import Pageloader from '../../components/shared/Pageloader'
import { CircleCheck, CircleX, CirclePlus, AlignLeft } from 'lucide-react'
import { HiPencil } from 'react-icons/hi'
import CustomFormBuilder from './CustomFormBuilder'
import DivLoader from '../../components/shared/DivLoader'
import './MergeQuestion.css'

const MergeQuestion = () => {
  const [boxView, setBoxView] = useState('list')
  const [active, setActive] = useState('list')
  const [currentView, setCurrentView] = useState('list')
  const [diagnosisData, setDiagnosisData] = useState([])
  const [fetchedQuestions, setFetchedQuestions] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [editComponentType, setEditComponentType] = useState(null)
  const [editDiagnosis, setEditDiagnosis] = useState(null)
  const [questionType, setQuestionType] = useState([
    { value: 'HPI', label: 'HPI Question' },
    { value: 'followup', label: 'Subjective Question' },
    { value: 'Incident', label: 'Incident Question' },
  ])

  const GetFormDataForDiagnosis = async (type, diagnosis) => {
    let formattedData = await SaveQuestionProvider('GET', '', type, diagnosis.toString(), '')

    if (formattedData) {
      formattedData = JSON.parse(formattedData.d)?.Data || []
      formattedData = formattedData[0] || []

      if (formattedData.questionData) {
        formattedData = {
          ...formattedData,
          questionData: JSON.parse(formattedData.questionData).filter((item) => item !== null),
        }
      }

      return !Array.isArray(formattedData) > 0 && formattedData
    }
  }

  const getDiagnosis = async () => {
    try {
      const response = await GetDiagnosisData()
      const data = JSON.parse(response.d)
      const options = data.Data.sort((a, b) => a.Name.trim().localeCompare(b.Name.trim())).map((obj) => ({
        value: obj.id,
        label: obj.Name.trim(),
      }))

      setDiagnosisData(options)
    } catch (error) {
      console.error('Error fetching diagnosis data:', error)
    }
  }

  const getQuestion = async () => {
    try {
      const questions = await Promise.all(
        questionType.map(async (item) => {
          const questionData = await Promise.all(
            diagnosisData.map(async (diag) => {
              const result = await GetFormDataForDiagnosis(item.value, diag.value)
              return result || null
            }),
          )

          const filteredQuestions = questionData.filter((res) => res !== null)
          return { questionType: filteredQuestions, item }
        }),
      )

      setFetchedQuestions(questions)
    } catch (error) {
      console.error('Error fetching questions:', error)
    }
  }

  // if (fetchedQuestions) {

  //     if (fetchedQuestions[0]?.questionType?.length === 0) {
  //         getQuestion()
  //     }
  // }

  useEffect(() => {
    const fetchData = async () => {
      await getDiagnosis()
      await getQuestion()
    }

    fetchData()
  }, [])

  useEffect(() => {
    if (fetchedQuestions[0]?.questionType?.length === 0) {
      getQuestion()
    } else if (fetchedQuestions[0]?.questionType?.length > 0) {
      setIsPageLoading(false)
    }
  }, [fetchedQuestions])

  const handleEdit = (type, diagnosis) => {
    setEditComponentType(type)
    setEditDiagnosis(diagnosis)
    setCurrentView('formBuilder')
    setBoxView('edit')
    setActive('edit')
  }

  const renderView = () => {
    if (currentView === 'formBuilder') {
      return <CustomFormBuilder componentType={editComponentType} componentDiagnosis={editDiagnosis} />
    }

    if (currentView === 'add') {
      return <CustomFormBuilder />
    }

    if (currentView === 'list') {
      return (
        <DivLoader isLoading={isPageLoading}>
          <div className="merge-question-theme__content">
            {fetchedQuestions[0]?.questionType?.length > 0 && (
              <div>
                {active === 'list' && (
                  <div className="merge-question-theme__list-shell">
                    <CRow className="merge-question-theme__grid">
                      {diagnosisData.map((item, index) => (
                        <CCol xs={4} key={index}>
                          <CCardBody className="merge-question-theme__card-body">
                            <div className="merge-question-theme__card">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h5 className="merge-question-theme__card-title">{item.label}</h5>
                              </div>
                              <div className="mt-2">
                                {questionType.map((data, qIndex) => {
                                  const checkDiagnosisExists = fetchedQuestions.filter((filterType) => filterType.item.value === data.value)

                                  const checkTypeDiagnosis = checkDiagnosisExists.flatMap((checkType) => checkType.questionType.filter((diagData) => diagData.diagnosisID === item.value.toString()))

                                  let filterToRemoveNull = checkTypeDiagnosis.filter((nullCheck) => {
                                    if (nullCheck?.questionType?.questionData?.length === 0) {
                                      return false
                                    }
                                    return true
                                  })

                                  return (
                                    <div
                                      key={qIndex}
                                      className={`d-flex align-items-center justify-content-between py-2 merge-question-theme__row ${qIndex < questionType.length - 1 ? 'merge-question-theme__row--divider' : ''}`}
                                    >
                                      <div className="merge-question-theme__row-label">{data.label}</div>
                                      <div>{checkTypeDiagnosis.length > 0 && checkTypeDiagnosis[0]?.questionData?.length > 0 ? <CircleCheck className="merge-question-theme__status-icon merge-question-theme__status-icon--success" /> : <CircleX className="merge-question-theme__status-icon merge-question-theme__status-icon--danger" />}</div>
                                      <div onClick={() => handleEdit(data, item)} className="merge-question-theme__edit-button" role="button">
                                        <HiPencil size={18} />
                                      </div>
                                    </div>
                                  )
                                })}
                              </div>
                            </div>
                          </CCardBody>
                        </CCol>
                      ))}
                    </CRow>
                  </div>
                )}
              </div>
            )}
          </div>
        </DivLoader>
      )
    }
  }

  return (
    <div className="merge-question-theme">
      <CCard className="merge-question-theme__toolbar">
        <CCardBody className="p-0">
          <div className="d-flex align-items-center justify-content-end merge-question-theme__toolbar-body">
            <CButton
              onClick={() => {
                setBoxView('list')
                setActive('list')
                setCurrentView('list')
                getQuestion()
              }}
              color="light"
              className={`d-flex align-items-center justify-content-center merge-question-theme__view-toggle ${boxView === 'list' ? 'merge-question-theme__view-toggle--active' : ''}`}
            >
              <AlignLeft size={16} strokeWidth={1.25} />
              <div className="merge-question-theme__view-toggle-label">List</div>
            </CButton>
            {/* <CButton
                        onClick={() => {
                            setBoxView('add');
                            setActive('add');
                            setCurrentView('add')
                        }}
                        style={{
                            background: boxView === 'add' ? '#e9ebff' : '#fff',
                            height: '40px',
                            padding: '5px 10px',
                            borderRadius: '5px',
                            marginLeft: '10px',
                            boxShadow: boxView === 'add' ? '0px 2px 4px rgba(0, 0, 0, 0.1)' : 'none',
                        }}
                        color={boxView === 'add' ? 'primary' : 'light'}
                        className="text-black d-flex align-items-center justify-content-center"
                    >
                        <CirclePlus size={16} strokeWidth={1.25} />
                        <div style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500' }}>
                            Add
                        </div>
                    </CButton> */}

            {currentView === 'formBuilder' ? (
              <CButton
                color="light"
                className={`d-flex align-items-center justify-content-center merge-question-theme__view-toggle ${boxView === 'edit' ? 'merge-question-theme__view-toggle--active' : ''}`}
              >
                <CirclePlus size={16} strokeWidth={1.25} />
                <div className="merge-question-theme__view-toggle-label">Edit</div>
              </CButton>
            ) : (
              <CButton
                onClick={() => {
                  setBoxView('add')
                  setActive('add')
                  setCurrentView('add')
                }}
                color="light"
                className={`d-flex align-items-center justify-content-center merge-question-theme__view-toggle ${boxView === 'add' ? 'merge-question-theme__view-toggle--active' : ''}`}
              >
                <CirclePlus size={16} strokeWidth={1.25} />
                <div className="merge-question-theme__view-toggle-label">Add</div>
              </CButton>
            )}
          </div>
        </CCardBody>
      </CCard>

      {renderView()}
    </div>
  ) 
}

export default MergeQuestion
